import script from "./results-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./results-list.vue?vue&type=script&setup=true&lang=ts"

import "./results-list.vue?vue&type=style&index=0&id=5eb7e9de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb7e9de"]])

export default __exports__